import type { Formatter, MessageFormatterParams } from 'ag-charts-types';

import type { ModuleInstance } from '../module/baseModule';
import { BaseModuleInstance } from '../module/module';
import type { ModuleContext } from '../module/moduleContext';
import { ObserveChanges } from '../util/proxy';
import { FUNCTION, PLAIN_OBJECT, TempValidate } from '../util/validation';

export class Locale extends BaseModuleInstance implements ModuleInstance {
    @ObserveChanges<Locale>((target) => {
        target.ctx.localeManager.setLocaleText(target.localeText);
    })
    @TempValidate(PLAIN_OBJECT, { optional: true })
    localeText: Record<string, string> | undefined = undefined;

    @ObserveChanges<Locale>((target) => {
        target.ctx.localeManager.setLocaleTextFormatter(target.getLocaleText);
    })
    @TempValidate(FUNCTION, { optional: true })
    getLocaleText: Formatter<MessageFormatterParams> | undefined;

    constructor(private readonly ctx: ModuleContext) {
        super();
    }
}
